var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters, Utils, Debounce, ViewChild, CommandEventName, CustomUIEvent, Components, Logging } from '@pacem/pacem-core';
import { DataColumnSortEvent, DataColumnSortEventName, DataColumnRescaleEvent, DataColumnRescaleEventName } from './headcell';
import { DataRowSelectChangeEvent } from './datacell';
//namespace Pacem.Components.Plus {
const DataColumnRebuildEventName = 'datacolumnchange';
const DataColumnStateChangeEventName = 'datacolumnstatechange';
const DataGridConsts = {
    Defaults: {
        selectCaption: 'Details',
        editCaption: 'Edit',
        editIcon: 'edit',
        deleteCaption: 'Delete',
        deleteIcon: 'delete'
    }
};
export class DataGridBindEvent extends CustomEvent {
    constructor(detail) {
        super('databind', { cancelable: false, bubbles: false, detail });
    }
}
export class DataCellUIEvent extends CustomUIEvent {
    constructor(type, detail, orig) {
        super(type, detail, { bubbles: false, cancelable: true }, orig);
    }
}
let PacemDataColumnElement = class PacemDataColumnElement extends Components.PacemItemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'field':
                case 'headcellCss':
                case 'headcellCssClass':
                case 'datacellCss':
                case 'datacellCssClass':
                case 'resizable':
                case 'togglable':
                case 'sortable':
                case 'label':
                    this.dispatchEvent(new Event(DataColumnRebuildEventName));
                    break;
                case 'order':
                case 'hide':
                    this.dispatchEvent(new Event(DataColumnStateChangeEventName));
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemDataColumnElement.prototype, "field", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemDataColumnElement.prototype, "label", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemDataColumnElement.prototype, "resizable", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemDataColumnElement.prototype, "togglable", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemDataColumnElement.prototype, "sortable", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataColumnElement.prototype, "order", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json /*OrString (TODO)*/ })
], PacemDataColumnElement.prototype, "format", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataColumnElement.prototype, "headcellCss", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataColumnElement.prototype, "headcellCssClass", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataColumnElement.prototype, "datacellCss", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataColumnElement.prototype, "datacellCssClass", void 0);
PacemDataColumnElement = __decorate([
    CustomElement({ tagName: P + '-datacolumn' })
], PacemDataColumnElement);
export { PacemDataColumnElement };
function headColumnHtml(c) {
    return `<${P}-headcell metadata="{{ :host._getColumnMetadata('${c.prop}') }}" state="{{ :host._columnState.${c.prop} }}" grid-state="{{ :host._gridState }}"
on-${DataColumnSortEventName}=":host._broadcastSortCommand($event)"
on-${DataColumnRescaleEventName}=":host._broadcastRescaleCommand($event)"></${P}-headcell>`;
}
function dataColumnHtml(c, extra) {
    return `<${P}-datacell metadata="{{ :host._getColumnMetadata('${c.prop}') }}" state="{{ :host._columnState.${c.prop} }}" grid-state="{{ :host._gridState }}"
dataitem="{{ ^item }}" rowindex="{{ ^index }}" ${extra}></${P}-datacell>`;
}
let PacemDataGridElement = class PacemDataGridElement extends Components.PacemItemsContainerElement {
    constructor(_key = Utils.uniqueCode()) {
        super();
        this._key = _key;
        this.state = {};
        // TODO: allow to persist states (key) on the session or location level...
        this._columnState = {};
        this._gridState = { sort: {}, orderedColumns: [], selectedRows: [] };
        this._itemDataColumnRebuildHandler = (evt) => {
            this._adaptColumnMetadata(this.items || []);
        };
        this._itemDataColumnChangeHandler = (evt) => {
            this._adaptColumnMetadata(this.items || []);
        };
        this._memoizer = {};
    }
    validate(item) {
        return item instanceof PacemDataColumnElement;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.addEventListener(CommandEventName, this._onCommand, false);
        this._adaptColumnMetadata();
        const cols = this._adaptedColumnMetadata || [];
        this._buildUpGrid(cols);
    }
    disconnectedCallback() {
        this.removeEventListener(CommandEventName, this._onCommand, false);
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'items':
                case 'metadata':
                    this._adaptColumnMetadata();
                    break;
                case '_adaptedColumnMetadata':
                    this._buildUpGrid(val);
                    break;
                case 'datasource':
                    // cleanup row selection as datasource changes...
                    const eventArgs = { keepRowSelection: false, datasource: val };
                    const event = new DataGridBindEvent(eventArgs);
                    this.dispatchEvent(event);
                    if (!eventArgs.keepRowSelection) {
                        this._setRowSelection();
                    }
                    break;
                case 'state':
                    this._mergeState(val);
                    break;
            }
        }
    }
    register(item) {
        if (super.register(item)) {
            // add listeners
            item.addEventListener(DataColumnRebuildEventName, this._itemDataColumnRebuildHandler, false);
            item.addEventListener(DataColumnStateChangeEventName, this._itemDataColumnChangeHandler, false);
            return true;
        }
        return false;
    }
    unregister(item) {
        if (super.unregister(item)) {
            // remove listeners
            item.removeEventListener(DataColumnRebuildEventName, this._itemDataColumnRebuildHandler, false);
            item.removeEventListener(DataColumnStateChangeEventName, this._itemDataColumnChangeHandler, false);
            return true;
        }
        return false;
    }
    /**
     * Sets the selected rows among the current ones.
     * @param args
     */
    setRowSelection(...args) {
        const indices = Array.from(args);
        this._setRowSelection(indices);
    }
    _setRowSelection(indices) {
        const args = (indices || []).map(i => { return { item: this.datasource[i], index: i }; });
        const evt = new DataRowSelectChangeEvent({ selectedRows: args });
        this.dispatchEvent(evt);
        if (!evt.defaultPrevented) {
            let retval = evt.detail.selectedRows;
            if (!Utils.isArray(retval)) {
                retval = [];
            }
            this._doSetRowSelection(retval.map(i => (i?.index ?? -1)).filter(i => i >= 0));
        }
    }
    _doSetRowSelection(selectedRows) {
        const selection = { selectedRows };
        this._mergeState(selection);
    }
    /**
     * Merges and synchronizes grid states (public vs private).
     * @param state Partial state to be merged
     */
    _mergeState(state = this.state) {
        state ??= {};
        // normalize selected rows into numbers
        const normalizedState = { selectedRows: (state.selectedRows || []).map((i) => typeof i === 'number' ? i : i.index) };
        const newState = this._gridState = Utils.extend({}, this._gridState, state, normalizedState);
        // does not trigger propertychange event (does not have to).
        this.state = Utils.extend(this.state ?? {}, newState);
    }
    _adaptColumnMetadata(items = this.items, metadata = this.metadata) {
        const output = Array.prototype.concat.apply((items || []).map(i => {
            const retval = {
                prop: i.field,
                // format: i.format,
                headCell: {
                    name: i.label, cssClass: i.headcellCssClass || [], css: i.headcellCss || {}
                },
                dataCell: {
                    format: i.format, cssClass: i.datacellCssClass || [], css: i.datacellCss || {}
                },
                hide: i.hide,
                isRescalable: i.resizable,
                isSortable: i.sortable,
                isTogglable: i.togglable,
                order: i.order,
                width: 1,
            };
            return retval;
        }), metadata || []);
        this._memoizer = {};
        this._adaptedColumnMetadata = output;
    }
    _getColumnMetadata(prop) {
        return this._memoizer[prop] = this._memoizer[prop] || this._adaptedColumnMetadata.find(m => m.prop === prop);
    }
    _buildUpGrid(metadata) {
        const container = this._tableContainer;
        if (Utils.isNull(container)) {
            return;
        }
        if (Utils.isNullOrEmpty(metadata)) {
            container.innerHTML = '';
            return;
        }
        const options = this.options = Utils.extend({}, DataGridConsts.Defaults, this.options || {}), hasCommands = options.allowDelete || options.allowEdit || options.allowSelect, multiSelect = options.allowMultiSelect && hasCommands;
        let css = multiSelect ? 'auto ' : '', headcells = multiSelect ? `<div class="${PCSS}-headcell"></div>` : '', datacells = multiSelect ? `<${P}-panel class="${PCSS}-datacell" style="grid-column: 1;" css="{{ {'grid-row': ^index+2} }}"></${P}-panel>` : '', footcells = multiSelect ? `<div class="${PCSS}-footcell"></div>` : '';
        // 1-based column index
        let colIndex = multiSelect ? 2 : 1;
        const colCount = multiSelect ? (metadata.length + 2) : (hasCommands ? (metadata.length + 1) : metadata.length);
        this._gridState.orderedColumns = metadata.sort((i, j) => ((i.order ?? 0) - (j.order ?? 0))).map(i => i.prop);
        let extraUi = '';
        for (let evtType of Components.PacemElement.emittedEventTypes) {
            extraUi += ` on-${evtType}=":host._broadcastUiEvent(^item, ^index, $event)"`;
        }
        // loop
        for (let c of metadata) {
            this._columnState[c.prop] = {
                hidden: c.hide
            };
            // css
            css += this._getColumnSize(c).replaceAll(' ', '') + ' ';
            // headcell
            headcells += headColumnHtml(c);
            // datacell
            datacells += dataColumnHtml(c, extraUi);
            // footcell
            // end-of-loop
            colIndex++;
        }
        datacells += `<${P}-panel class="${PCSS}-datarow" css-class="{{ {'datarow-alt': ^index % 2 === 1, 'datarow-first': ^index === 0, 'datarow-last': ^index === (:host.datasource.length - 1), 'datarow-selected': :host._gridState.selectedRows.indexOf(^index) >= 0 } }}" style="grid-column: 1 /span ${colCount};" css="{{ {'grid-row': ^index+2} }}"></${P}-panel>`;
        const html = `<${P}-repeater datasource="{{ :host.datasource }}">
<${P}-panel class="${PCSS}-datatable" css="{{ {'grid-template-columns': :host._getColumnSizes(:host._columnState, '${css.trimEnd()}', :host._gridState) } }}">
    ${headcells}
    <template>
    ${datacells}
    </template>
    ${footcells}
</${P}-panel>`;
        container.innerHTML = html;
    }
    _getColumnSizes(state = this._columnState, css, grid = this._gridState) {
        if (Utils.isNullOrEmpty(state)) {
            return css;
        }
        const split = css.split(' ');
        for (let prop in state) {
            const col = state[prop];
            const ndx = grid.orderedColumns.indexOf(prop);
            if (col.hidden) {
                split[ndx] = 'auto';
            }
            else if (col.pixelWidth > 0) {
                split[ndx] = col.pixelWidth + 'px';
            }
        }
        return split.join(' ');
    }
    _getColumnSize(c) {
        if (c.hide) {
            return 'auto';
        }
        const min = c.minPixelWidth, max = c.maxPixelWidth;
        if (max > 0 && min > 0) {
            return `minmax(${min}px, ${max}px)`;
        }
        else {
            const flexWidth = typeof c.width === 'number' ? (c.width + 'fr') : 'auto';
            if (min > 0) {
                return `minmax(${min}px, ${flexWidth})`;
            }
            if (max > 0) {
                return `minmax(${flexWidth}, ${max}px)`;
            }
            return flexWidth;
        }
    }
    //#endregion
    //#region events
    _onCommand(evt) {
        // DO NOT stop bubbling! Might be 'handy' in autogenerated forms...
        // Pacem.stopPropagationHandler(evt);
        // ...But might lead to unwanted behaviors in nested repeaters.
        // Thus include the 'originalEvent' in the outscoped one as a read-only property.
        // 'itemcommand' event fires first
        this.dispatchEvent(new Components.ItemCommandEvent(/* 'originalEvent' */ evt));
        // custom 'item<cmd>' event fires next
        this.dispatchEvent(new Components.CustomItemCommandEvent(/* 'originalEvent' */ evt));
    }
    _broadcastUiEvent(item, index, evt) {
        const evtType = evt.type.toLowerCase(), type = 'datacell' + evtType;
        const args = { dataitem: item, rowindex: index, datacell: evt.srcElement }, uiEvt = (evt instanceof MouseEvent || evt instanceof TouchEvent || evt instanceof KeyboardEvent) ? new DataCellUIEvent(type, args, evt) : new DataCellUIEvent(type, args);
        this.dispatchEvent(uiEvt);
        if (evtType === 'click' && !uiEvt.defaultPrevented) {
            const datacell = uiEvt.detail.datacell;
            const selectMode = datacell.metadata?.dataCell?.selectMode?.toLowerCase();
            switch (selectMode) {
                case 'cell':
                    break;
                case 'row':
                    this._broadcastSelectCommand(uiEvt.detail.rowindex);
                    break;
            }
        }
    }
    _broadcastSortCommand(evt) {
        const sort = evt.detail;
        const event = new DataColumnSortEvent(sort);
        this.dispatchEvent(event);
        if (!event.defaultPrevented) {
            const sort2 = { column: '' };
            if (typeof event.detail.column === 'string') {
                sort2.column = event.detail.column;
            }
            if (typeof event.detail.dir === 'string') {
                sort2.dir = event.detail.dir === 'desc' ? 'desc' : 'asc';
            }
            this._gridState = Utils.extend({}, this._gridState, /* let it be manipulated on the "other side" */ { sort: sort2 });
        }
    }
    _broadcastRescaleCommand(evt) {
        const rescale = evt.detail;
        const event = new DataColumnRescaleEvent(rescale);
        this.dispatchEvent(event);
        if (!event.defaultPrevented) {
            let width2 = rescale.width;
            if (typeof event.detail.width === 'number' && event.detail.width > 0) {
                width2 = event.detail.width;
            }
            const column = evt.srcElement.metadata;
            const newState = {};
            newState[column.prop] = { pixelWidth: width2 };
            this._columnState = Utils.extend({}, this._columnState, newState);
        }
    }
    _broadcastSelectCommand(toggledRowIndex) {
        let actualRows = (this._gridState.selectedRows || []).slice(0);
        const ndx = actualRows.indexOf(toggledRowIndex);
        let trigger = true;
        if (ndx >= 0) {
            actualRows.splice(ndx, 1);
        }
        else {
            const options = this.options;
            if (options.allowMultiSelect) {
                actualRows.push(toggledRowIndex);
            }
            else if (options.allowSelect) {
                actualRows = [toggledRowIndex];
            }
            else {
                trigger = false;
                const msg = `Cannot select the row at index ${toggledRowIndex} since datagrid options do not allow any row selection.`;
                if (Utils.isNull(this.logger)) {
                    console.warn(msg);
                }
                else {
                    this.log(Logging.LogLevel.Warn, msg);
                }
            }
        }
        if (trigger) {
            this._setRowSelection(actualRows);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemDataGridElement.prototype, "metadata", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemDataGridElement.prototype, "options", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemDataGridElement.prototype, "state", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemDataGridElement.prototype, "datasource", void 0);
__decorate([
    ViewChild('.' + PCSS + '-datagrid')
], PacemDataGridElement.prototype, "_tableContainer", void 0);
__decorate([
    Watch()
], PacemDataGridElement.prototype, "_adaptedColumnMetadata", void 0);
__decorate([
    Watch()
], PacemDataGridElement.prototype, "_columnState", void 0);
__decorate([
    Watch()
], PacemDataGridElement.prototype, "_gridState", void 0);
__decorate([
    Debounce()
], PacemDataGridElement.prototype, "_adaptColumnMetadata", null);
PacemDataGridElement = __decorate([
    CustomElement({ tagName: P + '-datagrid', shadow: false, template: `<div class="${PCSS}-datagrid"></div><${P}-content></${P}-content>` })
], PacemDataGridElement);
export { PacemDataGridElement };
